import httpClient from '../../../../shared/services/http/http-client';
import { ICommitAllImportLinesRequest, ICommitAllImportLinesResult, IDiscardedImportAndIntegrationLines, IFormattedDiscardImportLine, IFormattedImportLine, IFormattedPostImportLine, IImportLine } from './third-party-connection-import-line.model';

export default class ThirdPartyConnectionImportLineService {

  // Switch a line onto a different source's activity. The activity itself is resolved by the
  // backend, never sent from here: a client that could name both the source and the factor
  // could label any factor however it liked.
  async switchActivitySource(lineId: string, source: 'NOMINAL_MAPPING' | 'SUPPLIER_DEFAULT'): Promise<IImportLine> {
    return this.http.post(`third-party-connection-import/${lineId}/activity-source`, { source })
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
  http;
  constructor() {
    this.http = httpClient
  }

  async createImportLine(importLine: IFormattedPostImportLine): Promise<IFormattedPostImportLine> {
    return this.http.post(`third-party-connection-import/create-imports`, importLine)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async editImportLine(id: string, updatedLine: any): Promise<any> {
    return this.http.patch(`third-party-connection-import/${id}`, updatedLine)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async discardImportLine(importLine: IFormattedDiscardImportLine): Promise<IFormattedDiscardImportLine> {
    return this.http.post(`third-party-connection-import/discard-imports`, importLine)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // Commit everything ready in the review's current view. Without `confirm` it only counts, for
  // the confirmation dialog; with it the server commits in bounded batches and says how many
  // lines remain, so the caller repeats until none do.
  async commitAllImportLines(request: ICommitAllImportLinesRequest): Promise<ICommitAllImportLinesResult> {
    return this.http.post(`third-party-connection-import/commit-all`, request)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllImportLinesWithPagination(queryString: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IFormattedImportLine[], years?: number[], providerCodes?: string[] }> {
    return this.http.get(`third-party-connection-import/get-all-import-lines${queryString}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return {
          years: response.data.years,
          providerCodes: response.data.providerCodes,
          count: response.data.count,
          rows: response.data.rows.map((line: IImportLine) => {
            return { ...line, isSelected: false, isDefault: true }
          })
        }
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOneImportLine(importLineId: string): Promise<IImportLine> {
    return this.http.get(`third-party-connection-import/get-all-import-lines/${importLineId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getDiscardedSpendBasedImportAndIntegrationsWithPagination(queryString: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IDiscardedImportAndIntegrationLines[] }> {
    return this.http.get(`third-party-connection-import/get-all-discarded-lines${queryString}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

}